export const MAYORS = 1;
export const AGREED = 2;
export const ACCOUNTANTS = 3;
export const ARCHITECTS = 4;
export const PREPARED = 334;
export const EMPLOYEES = 335;
export const OEKKTO = 336;
export const DIRECTION_BF = 337;